import modelsResolver from 'utils/api/models/utils/modelsResolver';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';

const model: types.models.InputModel = {
	_entry: 'response.catalogEntryView',
	packages: (model: SinglePackage) => {
		const packages = ((model._entry || []) as any).map((singlePackage: any) =>
			modelsResolver({ entry: singlePackage }, 'singlePackage')
		);
		return packages;
	},
};

export default model;
